(function($) {
    var toggleForm = $('.single-format-aside .order-form-toggle');
    var toggleInfo = $('.single-format-aside .order-form-info-section .info-section-header');

    if (!toggleForm.length) {
        return;
    }

    toggleForm.click( function() {
        if ( $('.order-form-wrapper').css('position') !== 'absolute' ) {
            $(this).siblings('div').slideToggle();
            $(this).toggleClass('toggled-on');
        }
    });

    toggleInfo.click( function() {
        $(this).next().slideToggle();
        $(this).toggleClass('toggled-on');
    });
})(jQuery);
